import { HostHandshake } from '../Handshake';
import { AbstractHostEndpoint } from './AbstractEndpoint';
import { HostChannel } from '../HostChannel';

export class WorkerHostEndpoint extends AbstractHostEndpoint {
  static connect(worker: Worker, cb: (transport: HostChannel) => void) {
    const host = new WorkerHostEndpoint(worker);

    host.onConnect((port) => {
      const instance = new HostChannel(port);
      cb(instance);
    });
  }

  handshake: HostHandshake;

  constructor(private worker: Worker) {
    super();

    this.handshake = new HostHandshake(
      (message, port) => {
        if (port) {
          this.worker.postMessage(message, [port]);
        } else {
          this.worker.postMessage(message);
        }
      },
      (listener) => {
        this.worker.addEventListener('message', listener);
      },
    );
  }
}
